import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
} from "@angular/core";
import {
  FlexLayoutModule,
  MediaObserver,
  MediaChange,
} from "@angular/flex-layout";
import { Subscriber, Subscription } from "rxjs";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import * as _ from "lodash";

import { ToastService } from "src/app/services/toast/toast.service";
import { TranslateService } from "@ngx-translate/core";
import { LoginService } from "src/app/services/login/login.service";
import { MQTTService } from "src/app/services/mqtt/mqtt.service";

import { GetDatePipe } from "src/app/pipes/pipes/pipe-date.pipe";
import { ActivatedRoute } from "@angular/router";
import { StatusService } from "src/app/services/status/status.service";
import { UserService } from "src/app/services/user/user.service";
import { UserModel } from "src/app/models/userModel";
import { QueryRef } from "apollo-angular";
import gql from "graphql-tag";

import { Apollo } from "apollo-angular";
import { IncidentsService } from "src/app/services/incidents/incidents.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

@Component({
  selector: "app-status",
  templateUrl: "./status.component.html",
  styleUrls: ["./status.component.scss"],
  providers: [GetDatePipe],
})
export class StatusComponent implements OnInit {
  activatedStyle = false;
  isSelected = false;
  enableAlarmasDetail = false;
  enableAlarmasForm = false;
  elementUserData: UserModel[] = [];
  elementUserDataAux: UserModel[] = [];

  formMode = "";
  isAdmin = false;
  loadingText = "LOADING.ALARMAS";
  showAlarmas = false;
  loading = false;

  mobileMode: boolean = false;
  private mediaSub: Subscription;
  userId: string;
  filter = "";
  currentAlarm: string;

  statusData: any;
  mqttSubscription: Subscription;
  query: QueryRef<any>;
  dashboard = {
    data: {
      robot: {
        operation: {
          manual: false,
          screen: true,
          automatic: false,
        },
        head: {
          turn: {
            clockwise: false,
            anticlockwise: true,
            position: 0,
          },
          elevation: {
            up: false,
            down: true,
            position: 0,
          },
        },
        mast: {
          turn: {
            clockwise: true,
            anticlockwise: false,
            position: 0,
          },
          elevation: {
            position: 0,
            speed: 0,
            up: true,
            down: false,
          },
        },
        water: {
          level: {
            max: false,
            min: false,
            evinput: false,
          },
          liters: 0,
        },
        furnace: {
          head: {
            elevation: false,
            origin: false,
          },
          mast: {
            elevation: false,
            parking: false,
          },
          radio: false,
        },
        hydraulic: {
          level: false,
          filter: false,
          temperature: false,
          pressure: false,
          motor: false,
          evpressure: false,
          evsecurity: false,
          evblock: false,
        },
      },
      gunning: {
        operation: {
          manual: false,
          screen: true,
          automatic: false,
        },
        lid: {
          open: false,
          close: true,
        },
        vibrator: {
          on: false,
          off: true,
        },
        vessel: {
          pressure: {
            on: false,
            off: true,
          },
          load: {
            open: false,
            close: true,
          },
          discharge: {
            open: false,
            close: true,
          },
        },
        venting: {
          on: false,
          off: true,
        },
        transport: {
          on: false,
          off: true,
        },
      },
    },
  };

  displayedColumnsRobotProcessVariables: string[] = [
    "uuid",
    "nombre",
    "fecha",
    "valor",
  ];
  dataSourceRobotProcessVariables: any;
  @ViewChild("paginatorRobotProcessVariables", { static: true })
  paginatorRobotProcessVariables: MatPaginator;
  displayedColumnsGunningMachineProcessVariables: string[] = [
    "uuid",
    "nombre",
    "fecha",
    "valor",
  ];
  @ViewChild(MatSort, { static: true }) sort1: MatSort;
  dataSourceGunningMachineProcessVariables: any;
  @ViewChild("paginatorGunningMachineProcessVariables", { static: true })
  paginatorGunningMachineProcessVariables: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort2: MatSort;
  robotVariables = [];
  gunningMachineVariables = [];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
    private fb: FormBuilder,
    private toastr: ToastService,
    private translate: TranslateService,
    private loginService: LoginService,
    private statusService: StatusService,
    private userService: UserService,
    private mqttService: MQTTService,
    private incidentsService: IncidentsService,
    private dialog: MatDialog,
    private getDatePipe: GetDatePipe,
    private route: ActivatedRoute,
    private apollo: Apollo
  ) {
    this.isAdminUser();
  }

  isAdminUser() {
    if (this.loginService.currentUserValue.rol.includes("admin")) {
      this.isAdmin = true;
    }
  }

  ngOnInit() {
    this.filter = this.route.snapshot.paramMap.get("filter");

    this.mediaSub = this.mediaObserver.media$.subscribe(
      (change: MediaChange) => {
        if (change.mqAlias == "xs" || change.mqAlias == "sm") {
          this.mobileMode = true;
        } else {
          this.mobileMode = false;
        }
      }
    );

    this.userId = this.loginService.currentUserValue.uuid;
    this.isAdminUser();

    //this.doInitStatusData();

    this.doLaunchMqttSubscription();
  }

  /*
  ngAfterInit(){
    this.changeDetectorRef.detectChanges();
  }
*/

  ngOnDestroy(): void {
    this.mediaSub.unsubscribe();
    this.doStopMqttSubscription();
  }

  doInitStatusData() {
    this.statusService.getRobotStatusFromJSONFile().subscribe(
      (data) => {
        this.statusData = JSON.parse(JSON.stringify(data));
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doGetStatusVariables() {
    this.incidentsService.getTiposIncidente().subscribe(
      (data) => {
        console.log(data);
        let date = Date.now();
        let results = [...data.data.findTipoDatoEstados];
        for (let i = 0; i < results.length; i++) {
          for (let j = 0; j < results[i].tipoDatoEstado.length; j++) {
            if (
              !results[i].tipoDatoEstado[j].nombre.includes("FALLO") &&
              results[i].nombre == "Gunitadora"
            ) {
              let result = { ...results[i].tipoDatoEstado[j] };

              if (
                result.nombre.includes("GUNITADORA") ||
                result.nombre.includes("GUNUTADORA") ||
                result.nombre.includes("CUBA") ||
                result.nombre.includes("MARCHA") ||
                result.nombre.includes("DESCOMPRESION")
              ) {
                result.dispositivo = results[i].nombre;
                result.dispositivoUuid = results[i].uuid;
                result.fecha = date;
                result.valor = false;
                this.gunningMachineVariables.push(result);
              } else {
                const dispositivo = results[i].nombre;
                const dispositivoUuid = results[i].uuid;
                const fecha = date;
                const valor = false;
                result = {
                  ...result,
                  dispositivo: dispositivo,
                  dispositivoUuid: dispositivoUuid,
                  fecha: fecha,
                  valor: valor,
                };

                this.robotVariables.push(result);
              }
            }
          }
        }
        console.log("Status Variables (Robot) -> ", this.robotVariables);
        this.doLoadRobotVariablesTableData(this.robotVariables);
        console.log(
          "Status Variables (Gunning Machine) -> ",
          this.gunningMachineVariables
        );
        this.doLoadGunningMachineVariablesTableData(
          this.gunningMachineVariables
        );
      },
      (err) => {
        console.log(err);
      }
    );
  }

  doStopMqttSubscription() {
    this.mqttSubscription.unsubscribe();
  }

  doLaunchMqttSubscription() {
    this.doGetStatusVariables();
    this.mqttSubscription = this.mqttService.listen().subscribe(
      (data) => {
        let mqttMessage = data.data.doGetMqttData;
        let variable = this.doGetVariableName(mqttMessage.topic);
        let fecha = mqttMessage.payload.fecha;
        let valor = mqttMessage.payload.valor;
        let notification =
          "Variable: " +
          variable +
          "<br/>Fecha: " +
          fecha +
          "<br/>Valor: " +
          valor;
        this.toastr.showInfo(notification, "MQTT Message");
        this.doUpdateTableData(variable, fecha, valor);
        this.doUpdateDashboardIcon(variable, valor);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  doTransformDate(stringDate) {
    if (stringDate != null && stringDate != "") {
      let d = new Date(stringDate);
      return d.toLocaleString();
    } else {
      let d = new Date();
      return d.toLocaleString();
    }
  }

  doGetVariableName(topic): string {
    let keyword = "VARIABLE";
    let variable = topic.substr(
      topic.indexOf(keyword) + keyword.length + 1,
      topic.length
    );
    variable = variable.substr(0, variable.indexOf("/"));
    return variable;
  }

  doLoadRobotVariablesTableData(data) {
    this.dataSourceRobotProcessVariables = new MatTableDataSource(data);
    this.paginatorRobotProcessVariables.pageSize = 10;
    this.paginatorRobotProcessVariables.pageIndex = 0;
    this.paginatorRobotProcessVariables.length = data.length;
    this.dataSourceRobotProcessVariables.paginator =
      this.paginatorRobotProcessVariables;
    this.sort1.sort(<MatSortable>{ id: "fecha", start: "desc" });
    this.dataSourceRobotProcessVariables.sort = this.sort1;
  }

  doLoadGunningMachineVariablesTableData(data) {
    this.dataSourceGunningMachineProcessVariables = new MatTableDataSource(
      data
    );
    this.paginatorGunningMachineProcessVariables.pageSize = 10;
    this.paginatorGunningMachineProcessVariables.pageIndex = 0;
    this.paginatorGunningMachineProcessVariables.length = data.length;
    this.dataSourceGunningMachineProcessVariables.paginator =
      this.paginatorGunningMachineProcessVariables;
    this.sort2.sort(<MatSortable>{ id: "fecha", start: "desc" });
    this.dataSourceGunningMachineProcessVariables.sort = this.sort2;
  }

  /*
  doReloadRobotVariablesTableData(data)
  {
    this.dataSourceRobotProcessVariables.data = [];
    this.dataSourceRobotProcessVariables.data = data;
    this.sort1.sort(<MatSortable>{ id: 'fecha', start: 'asc'});
    this.dataSourceRobotProcessVariables.sort = this.sort1;
  }

  doReloadGunningMachineVariablesTableData(data)
  {
    this.dataSourceGunningMachineProcessVariables.data = [];
    this.dataSourceGunningMachineProcessVariables.data = data;
    this.sort2.sort(<MatSortable>{ id: 'fecha', start: 'asc'});
    this.dataSourceGunningMachineProcessVariables.sort = this.sort2;
  }
  */

  doUpdateTableData(variable, fecha, valor) {
    for (let i = 0; i < this.robotVariables.length; i++) {
      if (this.robotVariables[i].nombre == variable) {
        this.robotVariables[i].fecha = fecha * 1000;
        this.robotVariables[i].valor = valor;
      }
    }
    for (let i = 0; i < this.gunningMachineVariables.length; i++) {
      if (this.gunningMachineVariables[i].nombre == variable) {
        this.gunningMachineVariables[i].fecha = fecha * 1000;
        this.gunningMachineVariables[i].valor = valor;
      }
    }
  }

  doUpdateDashboardIcon(variable, valor) {
    switch (variable) {
      case "NIVEL_MAXIMO_AGUA":
        this.dashboard.data.robot.water.level.max = valor == 0 ? false : true;
        break;
      case "MASTIL_ELEVACION_ARRIBA":
        this.dashboard.data.robot.mast.elevation.up = valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.mast.elevation.up -> ",
          this.dashboard.data.robot.mast.elevation.up
        );
        break;
      case "CABEZAL_ELEVACION_ARRIBA":
        this.dashboard.data.robot.head.elevation.up = valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.head.elevation.up -> ",
          this.dashboard.data.robot.head.elevation.up
        );
        break;
      case "CABEZAL_GIRO_EN_POSICION":
        this.dashboard.data.robot.head.turn.position = valor;
        break;
      case "PERMISO_ENTRADA_HORNO":
        break;
      case "CABEZAL_GIRO_ANTI_HORARIO":
        this.dashboard.data.robot.head.turn.anticlockwise =
          valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.head.turn.anticlockwise -> ",
          this.dashboard.data.robot.head.turn.anticlockwise
        );
        break;
      case "NIVEL_MINIMO_AGUA":
        this.dashboard.data.robot.water.level.min = valor == 0 ? false : true;
        break;
      case "CABEZAL_GIRO_HORARIO":
        this.dashboard.data.robot.head.turn.clockwise =
          valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.head.turn.clockwise -> ",
          this.dashboard.data.robot.head.turn.clockwise
        );
        break;
      case "MASTIL_GIRO_HORARIO":
        this.dashboard.data.robot.mast.turn.clockwise =
          valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.mast.turn.clockwise -> ",
          this.dashboard.data.robot.mast.turn.clockwise
        );
        break;
      case "CABEZAL_ELEVACION_SUBIR":
        this.dashboard.data.robot.head.elevation.up = valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.head.elevation.up -> ",
          this.dashboard.data.robot.head.elevation.up
        );
        break;
      case "CABEZAL_ELEVACION_BAJAR":
        this.dashboard.data.robot.head.elevation.down =
          valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.head.elevation.down -> ",
          this.dashboard.data.robot.head.elevation.down
        );
        break;
      case "MASTIL_GIRO_ANTI_HORARIO":
        this.dashboard.data.robot.mast.turn.anticlockwise =
          valor == 0 ? false : true;
        console.log(
          "this.dashboard.data.robot.mast.turn.anticlockwise -> ",
          this.dashboard.data.robot.mast.turn.anticlockwise
        );
        break;
      case "ENTRADA_AGUA":
        this.dashboard.data.robot.water.level.evinput =
          valor == 0 ? false : true;
        break;
      case "MASTIL_GIRO_POSICION_REPOSO":
        this.dashboard.data.robot.mast.turn.position = valor;
        break;
      case "CABEZAL_GIRO_POSICION":
        this.dashboard.data.robot.head.turn.position = valor;
        break;
      case "CABEZAL_ELEVACION_POSICION":
        this.dashboard.data.robot.head.elevation.position = valor;
        break;
      case "MOTOR_MASTIL_GIRO":
        this.dashboard.data.robot.mast.turn.position = valor;
        break;
      case "GUNITADORA_TOLVA_ABIERTA":
        this.dashboard.data.gunning.lid.open = valor == 0 ? false : true;
        break;
      case "GUNUTADORA_CUBA_DESCARGA_CERRADA":
        this.dashboard.data.gunning.vessel.discharge.close =
          valor == 0 ? false : true;
        break;
      case "ARRASTRE_MARCHA":
        this.dashboard.data.gunning.transport.on = valor == 0 ? false : true;
        if (valor == 1) this.dashboard.data.gunning.transport.off = false;
        else this.dashboard.data.gunning.transport.off = true;
        break;
      case "PRESION_CUBA_MARCHA":
        this.dashboard.data.gunning.vessel.pressure.on =
          valor == 0 ? false : true;
        if (valor == 1) this.dashboard.data.gunning.vessel.pressure.off = false;
        else this.dashboard.data.gunning.vessel.pressure.off = true;
        break;
      case "VIBRADOR_MARCHA":
        this.dashboard.data.gunning.vibrator.on = valor == 0 ? false : true;
        if (valor == 1) this.dashboard.data.gunning.vibrator.off = false;
        else this.dashboard.data.gunning.vibrator.off = true;
        break;
      case "DESCOMPRESION_ABRIR":
        this.dashboard.data.gunning.venting.on = valor == 0 ? false : true;
        if (valor == 1) this.dashboard.data.gunning.venting.off = false;
        else this.dashboard.data.gunning.venting.off = true;
        break;
      case "GUNITADORA_CUBA_CARGA_ABIERTA":
        this.dashboard.data.gunning.vessel.load.open =
          valor == 0 ? false : true;
        break;
      case "GUNITADORA_TOLVA_CERRADA":
        this.dashboard.data.gunning.lid.close = valor == 0 ? false : true;
        break;
      case "GUNITADORA_CUBA_DESCARGA_ABIERTA":
        this.dashboard.data.gunning.vessel.discharge.open =
          valor == 0 ? false : true;
        break;
      case "GUNITADORA_CUBA_CARGA_CERRADA":
        this.dashboard.data.gunning.vessel.load.close =
          valor == 0 ? false : true;
        break;
    }
  }
}
